module.exports = __webpack_public_path__ + "static/fonts/TTNorms-Medium.871c53b.eot";